import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";
import copyImg from "copy-image-clipboard";

@Component({
  selector: "app-media-upload-copy",
  templateUrl: "./media-upload-copy.component.html",
  styles: [],
})
export class MediaUploadCopyComponent implements OnInit {
  @Input() imageUploadContent: any;
  imageChangedEvent: any = "";
  uploadedImage = "";
  imageloader = true;

  apiUrl = JSON.parse(localStorage.getItem('client'))['apiUrl'] || environment.apiUrl;
  constructor(
    public service: PageService,
    public fb: FormBuilder,
    public dialogRef: NgbActiveModal,
    public http: HttpClient
  ) {}

  ngOnInit() {
    //console.log(this.imageUploadContent);
    this.fileChangeEvent(this.imageUploadContent.fileEvent);
  }
  fileChangeEvent(imageFile: any): void {
    var formData = new FormData();
    console.log(imageFile);
    formData.append("file", imageFile);
    const headers = new HttpHeaders({
      "x-access-token": localStorage.getItem("token"),
    });
    this.http
      .post(this.apiUrl + "cloudStorage/uploadFile/", formData, {
        headers: headers,
      })
      .subscribe((event) => {
        this.uploadedImage = event["data"];
        console.log(this.uploadedImage);
        this.copyImage(this.uploadedImage);
        this.imageloader = false;
      });
  }
  copyImage(url) {
    const customImage = document.querySelectorAll("body > #customImage");
    if (customImage[0]) {
      customImage[0].remove();
    }

    var img = document.createElement("img");
    img.src = url;
    img.style.height = 200 + "px";
    img.style.width = 400 + "px";
    img.style.objectFit = "cover";
    img.style.position = "center";

    document.body.appendChild(img);
    var r = document.createRange();
    r.setStartBefore(img);
    r.setEndAfter(img);
    r.selectNode(img);
    var sel = window.getSelection();
    sel.addRange(r);
    document.execCommand("Copy");
  }
  onSubmit() {
    copyImg(this.uploadedImage);
    
    this.dialogRef.close({
      success: { result: true, data: this.uploadedImage },
    });
  }
  close() {
    this.dialogRef.close({ success: false });
  }
}
